import { ADMIN_LANGUAGES } from "./LanguageTabs";

function CategoryModal({ category, setCategory, translating, onTranslate, onSave, onClose }) {
    const updateField = (field, value) => setCategory((current) => ({ ...current, [field]: value }));

    return (
        <div className="admin__modal-overlay" onClick={onClose}>
            <div className="admin__modal admin__modal--small card-common" onClick={(e) => e.stopPropagation()}>
                <div className="admin__modal-title-row">
                    <h2>{category.id ? "Editează" : "Adaugă"} Categorie</h2>
                    <button
                        type="button"
                        className="admin__btn-ai"
                        onClick={onTranslate}
                        disabled={translating || !String(category.name || "").trim()}>
                        {translating ? "Se traduce..." : "Tradu cu AI"}
                    </button>
                </div>
                <form onSubmit={onSave}>
                    {ADMIN_LANGUAGES.map((language) => (
                        <div className="admin__field" key={language.code}>
                            <label>
                                Nume ({language.name}){language.code === "ro" ? " *" : ""}
                            </label>
                            <input
                                type="text"
                                value={category[`name${language.suffix}`] || ""}
                                onChange={(e) => updateField(`name${language.suffix}`, e.target.value)}
                                required={language.code === "ro"}
                                placeholder={language.code === "ro" ? "" : "Gol = se afișează numele în română"}
                            />
                        </div>
                    ))}
                    <div className="admin__field">
                        <label>Culoare</label>
                        <div className="admin__color-input">
                            <input
                                type="color"
                                value={category.color || "#b33771"}
                                onChange={(e) => updateField("color", e.target.value)}
                            />
                            <input
                                type="text"
                                value={category.color || "#b33771"}
                                onChange={(e) => updateField("color", e.target.value)}
                                placeholder="#b33771"
                            />
                        </div>
                    </div>
                    <div className="admin__modal-actions">
                        <button type="button" onClick={onClose} disabled={translating}>
                            Anulează
                        </button>
                        <button type="submit" className="primary" disabled={translating}>
                            Salvează
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default CategoryModal;
